<template>
  <v-card outlined height="100%">
    <v-card-text class="ma-0 pa-0">
      <v-simple-table fixed-header height="calc(100vh - 550px)" dense>
        <thead>
          <tr>
            <th width="30px">Nr</th>
            <th width="30px">Öffentlich</th>
            <th>Name</th>
            <th>Farbe</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, itemObjKey) in kalender" :key="itemObjKey" v-if="item !== 'kalender'">
            <td>{{ item.nummer }}</td>
            <td>
              <v-icon v-if="item.isPublic">group</v-icon>
              <v-icon v-else>block</v-icon>
            </td>
            <td>{{ item.name }}</td>
            <td :style="'background-color: ' + item.farbe + ';'">{{ item.farbe.hex }}</td>
            <td><v-btn icon @click="(neuerKalender = item) && (istNeu = false)"><v-icon>edit</v-icon></v-btn></td>
          </tr>
        </tbody>
      </v-simple-table> 
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      
      <v-row>

        <v-col cols="4">
          <v-text-field dense hide-details :disabled="!istNeu" hint="Der Name kann später nicht mehr geändert werden!" outlined label="Name" v-model="neuerKalender.name"></v-text-field>
          <v-text-field dense hide-details outlined type="number" label="Nummer" v-model="neuerKalender.nummer"></v-text-field>
          <v-switch dense hide-details outlined label="Öffentlich (Der Kalender ist für alle Mitglieder sichtbar und kann abonniert werden. Ansonsten nur für Inhaber von Ämtern sichtbar.)" v-model="neuerKalender.isPublic"></v-switch>
        </v-col>
        <v-col cols="4"><v-color-picker dense hide-details outlined flat mode="hexa" v-model="neuerKalender.farbe" hide-mode-switch hide-canvas :swatches="swatches" show-swatches></v-color-picker></v-col>
        <v-col cols="6">
          <v-alert 
            border="bottom"
            color="accent"
            colored-border
            type="warning" 
            icon="warning">
            Einmal erstellte Kalender können nicht mehr umbenannt oder gelöscht werden!
          </v-alert>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-btn icon large @click="(neuerKalender = {}) && (istNeu = true)"><v-icon>settings_backup_restore</v-icon></v-btn>
          <v-btn icon class="primary" dark large @click="addKalender()"><v-icon>save</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    data () {
      return {
        search: '',
        neuerKalender: {},
        istNeu: true,
        swatches: [
          ['#FF0000', '#AA0000', '#550000'],
          ['#FFFF00', '#AAAA00', '#555500'],
          ['#00FF00', '#00AA00', '#005500'],
          ['#00FFFF', '#00AAAA', '#005555'],
          ['#0000FF', '#0000AA', '#000055']
        ]
      }
    },
    computed: {
      kalender () {
        const kalenderObj = this.$store.getters['einstellungen/einstellung']('alleKalender')
        console.log()
        const kalender = kalenderObj
          .filter(key => key !== 'kalender')
          .sort((a, b) => a.nummer - b.nummer)
        return kalender
      }
    },
    methods: {
      addKalender () {
        if (
          (this.neuerKalender.name) &&
          (this.neuerKalender.farbe) &&
          (this.neuerKalender.nummer)
        ) {
          let kalender = this.$store.getters['einstellungen/einstellung']('kalender')
          kalender[this.neuerKalender.name] = this.neuerKalender
          this.$store.dispatch('einstellungen/updateEinstellungData', kalender)
          this.istNeu = true
          this.neuerKalender = []
        } else {
          console.log('Nicht alle Felder ausgefüllt.')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Kalender.vue?67353669